import AppBar from '@material-ui/core/AppBar';
import { ThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectFooterTheme } from 'app/store/fuse/settingsSlice';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
}));

function FooterLayout1(props) {
	const footerTheme = useSelector(selectFooterTheme);
	const classes = useStyles();
	const { t } = useTranslation('fuse-layout');

	return (
		<ThemeProvider theme={footerTheme}>
			<AppBar
				id="fuse-footer"
				className="relative z-10 shadow-md"
				color="default"
				style={{ backgroundColor: footerTheme.palette.background.paper }}
			>
				<Toolbar className="min-h-16 md:min-h-32 px-8 sm:px-12 py-0 flex items-center overflow-x-auto justify-between">
					<div>
						<span>
							<span className='text-12 text-grey-500'>All the images have free licenses from&nbsp;</span>
							<a className="pr-8 text-12" href="https://freepik.com"  target="freepik">Freepik</a>
						</span>
					</div>
					<div className='flex items-center'>
						<Link className="px-8 text-12" to={{ pathname: "/terms-and-condition" }} target="termsCondition">{t("footer.acceptTerms")}</Link>
						<Link className="px-8 text-12" to={{ pathname: "/privacy-policy" }} target="privacyPolicy">{t("footer.privacyPolicy")}</Link>
					</div>
				</Toolbar>
			</AppBar>
		</ThemeProvider>
	);
}

export default React.memo(FooterLayout1);
